import { observer } from "mobx-react";
import { IconProps } from "../../../../../components/icons/icon-props-interface";
import "./rma-line.scss";
import Icon from "../../../../../components/icons/icon/icon";
import FontHeading3 from "../../../../../components/fonts/font-heading3/font-heading3";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import { FONT_VARIANT } from "../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import IconChevronRight from "../../../../../components/icons/icon-chevron-right/icon-chevron-right";
import IconInTransit from "../../../../../components/icons/icon-in-transit/icon-in-transit";
import IconPendingReturnToApprove from "../../../../../components/icons/icon-pending-return-to-approve/icon-pending-return-to-approve";
import IconRequireAttention from "../../../../../components/icons/icon-require-attention/icon-require-attention";
import IconReturnToBeSent from "../../../../../components/icons/icon-return-to-be-sent/icon-return-to-be-sent";
import IconShipmentReceived from "../../../../../components/icons/icon-shipment-received/icon-shipment-received";
import AHref from "../../../../../components/ahref/ahref";
import RmaCounterStore from "../../../stores/rma-counters-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
    counterStore: RmaCounterStore,
}

const RMAIconMap: {[key: string]: React.FC<IconProps>} = {
    'REQUESTS_REQUIRE_ATTENTION': IconRequireAttention,
    'NO_ISSUE_FOUND': IconRequireAttention,
    'PENDING_TO_APPROVE': IconPendingReturnToApprove,
    'RETURN_SHIPMENTS_TO_EXPECT': IconReturnToBeSent,
    'RETURN_SHIPMENTS_IN_TRANSIT': IconInTransit,
    'RECEIVED_SHIPMENTS_TO_RESOLVE': IconShipmentReceived
};

const EVENT_NAME_MAP: { [key: string]: string } = {
    'REQUESTS_REQUIRE_ATTENTION': 'd&_home_attention_requests',
    'NO_ISSUE_FOUND': 'd&_home_attention_requests',
    'PENDING_TO_APPROVE': 'd&_home_pending_requests',
    'RETURN_SHIPMENTS_TO_EXPECT': 'd&_home_shipments_to_send',
    'RETURN_SHIPMENTS_IN_TRANSIT': 'd&_home_shipments_in_transit',
    'RECEIVED_SHIPMENTS_TO_RESOLVE': 'd&_home_received_shipments',
};

const RmaLine: React.FC<IProps> = observer(({ counterStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const eventName = EVENT_NAME_MAP[counterStore.name] || '';

    const handleClick = () => {
        if (eventName) {
            rmsMixpanelStore.trackEvent(eventName, {});
        }
    };

    return (
        <AHref href={counterStore.link} target="_parent">
            <div className="rma-line-content" onClick={handleClick}>
                <Icon Component={RMAIconMap[counterStore.name]} />
                <FontHeading3 variant={FONT_VARIANT.BOLD}>{counterStore.count}</FontHeading3>
                <FontHeading4>{getTranslation(counterStore.name, 'dashboard-home')}</FontHeading4>
                <Icon Component={IconChevronRight} />
            </div>
        </AHref>
    );
});

export default RmaLine;
